<div
  class="thumbnails-wrapper"
  [attr.style]="sanitizer.bypassSecurityTrustStyle(inputThumbnailSize ? '--input-thumbnail-size: ' + inputThumbnailSize : '')"
>
  @for (pic of photos | slice: 0 : (photos.length > maxThumbnails ? maxThumbnails - 1 : photos.length); track pic; let i = $index) {
    <ion-thumbnail class="thumbnail" (click)="openPictureModal(i)">
      <img alt="" [src]="pic | safeUrl" />
    </ion-thumbnail>
  }
  @if (photos.length > maxThumbnails) {
    <ion-button class="more-pictures-button" color="medium" (click)="openPictureModal(maxThumbnails - 1)">
      +{{ photos.length - (maxThumbnails - 1) }}
    </ion-button>
  }
</div>
